exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stripe{background:#f9f9f9;border-top:1px solid #ccc;border-bottom:1px solid #ccc}.no-border td{border:0}.table.is-striped.no-border tbody tr:not(.is-selected):nth-child(2n) td:not(.dateHeader){border-top:1px solid #dbdbdb;border-bottom:1px solid #dbdbdb}td.dateHeader{background:#fff;border-bottom:3px solid #333;font-weight:700;padding-top:1em}.minutePage,.seconded span{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3753fa30","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Modules/Register/Resources/assets/js/components/Resolutions.vue
// module id = EG33
// module chunks = 0